// Point-in-polygon utilities for GeoJSON ward boundaries.
// Coordinates in GeoJSON are [lng, lat]. Ray-casting algorithm with hole support.

const pointInRing = (lng, lat, ring) => {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i][0], yi = ring[i][1];
    const xj = ring[j][0], yj = ring[j][1];
    const intersect = ((yi > lat) !== (yj > lat)) && (lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
};

const pointInPolygonRings = (lng, lat, rings) => {
  if (!Array.isArray(rings) || !rings.length) return false;
  if (!pointInRing(lng, lat, rings[0])) return false; // outer ring
  for (let h = 1; h < rings.length; h++) {
    if (pointInRing(lng, lat, rings[h])) return false; // inside a hole
  }
  return true;
};

export const pointInGeometry = (lat, lng, geometry) => {
  if (!geometry || !geometry.coordinates) return false;
  try {
    if (geometry.type === 'Polygon') return pointInPolygonRings(lng, lat, geometry.coordinates);
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.some((poly) => pointInPolygonRings(lng, lat, poly));
  } catch {
    return false;
  }
  return false;
};

// Returns the ward record whose official boundary polygon contains the point, or null.
// Never guesses: if the point is not clearly inside a polygon, returns null.
export const findWardForPoint = (lat, lng, wards) => {
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;
  for (const w of wards || []) {
    if (w?.geojson && pointInGeometry(lat, lng, w.geojson)) return w;
  }
  return null;
};
